export default __webpack_public_path__ + "static/media/tuongtinh.75694833.png";